module.exports = __webpack_public_path__ + "static/media/ten_monkeys.3fe4d688.gif";